import { render } from "./edit-role.vue?vue&type=template&id=a9c95aea"
import script from "./edit-role.vue?vue&type=script&lang=js"
export * from "./edit-role.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__